
window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

function handle_redirect_checkout() {
  const checkoutBtn = document.querySelector(".cart__checkout-button");
  if(checkoutBtn) {
    checkoutBtn.click()
  }

  return true;
  
}

window.BSS_B2B.addFilter('custom:redirect/checkout', handle_redirect_checkout);

//fix checkout v3
function fixCheckoutBtnSelector(checkoutElements) {
  const defaultBtnCheckout = document.querySelectorAll("button[name='checkout']");
  const customCheckout = document.querySelectorAll(".bss-checkout");

  if (defaultBtnCheckout.length && customCheckout.length) {
    defaultBtnCheckout.forEach(button => {
      button.style.display = "none";
    });
    customCheckout.forEach(button => {
      button.style.display = "block";
    });
  }
  return customCheckout;
}

window.BSS_B2B.addFilter('custom:cart/checkout_ele', fixCheckoutBtnSelector);


